import { render, staticRenderFns } from "./DaiConfirmationModal.vue?vue&type=template&id=42a5a03d&scoped=true&"
import script from "./DaiConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./DaiConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./DaiConfirmationModal.vue?vue&type=style&index=0&id=42a5a03d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a5a03d",
  null
  
)

export default component.exports